import { Type } from '@deqo/foundation';
import {
    PodSession,
    PodSessionWithPresenceFeatureType,
    PodSessionWithRelayFeatureType,
    PodSessionWithTopicFeatureType,
    WithPresenceFeature,
    WithRelayFeature,
    WithTopicFeature
} from '@deqo/podopolis';

export type HangoutPodSession =
    InstanceType<PodSessionWithPresenceFeatureType> &
    InstanceType<PodSessionWithRelayFeatureType> &
    InstanceType<PodSessionWithTopicFeatureType>;

export const HangoutPodSession = WithTopicFeature(WithRelayFeature(WithPresenceFeature(PodSession))) as Type<HangoutPodSession>;
